import React, { useState, /*useReducer,*/ useCallback, useEffect, useContext } from 'react';
import styled/*, { css }*/ from 'styled-components';
import { Buttons, HeaderContainer, BackButton, ValidationAlert } from '../../style';
import { SmallInput, PageHeader, Label, Button, Content } from 'scorer-ui-kit';
import { useTranslation } from 'react-i18next';
import { MenuContext, PathContext } from '../../App';
import useLocalStorage from '../../hooks/useLocalstorage';

const Container = styled(Content) <{ marginLeft?: string }>`
  display: flex;
  flex: 1;
  margin-left: ${({ marginLeft }) => marginLeft ? marginLeft : '295px'};
  
  //height: auto;  
  //width: 700px;
  height: 100%;
  width: 100%;
  max-width: 700px;
  flex-direction: column;
  padding: 67px 50px 25px 45px;
  transition: 0.2s;
  //overflow: initial;
  /*& > div {
    max-width: auto;
  }*/
`;

const InputContainer = styled.div`
  display: flex;
  width: inherit;
  margin: 5px 0 0 0;
  justify-content: space-between;
  height: 100px;
`;

const StartTypeContainer = styled.div`
  display: flex;
  width: inherit;
  margin: 5px 0 0 0;
  justify-content: space-between;
  height: 400px;
`;

const EndTypeContainer = styled.div`
  display: flex;
  width: inherit;
  margin: -100px 0 0 0;
  justify-content: space-between;
  height: 500px;
`;

const AreaInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  margin: 0 0 10px 0;
`;

const SelectFieldBox = styled.select`
  width: 104px;
  height: 30px;
  padding: 0 0 0 10px;
  border-radius: 3px;
  outline: none;
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 14px;
  color: #767676;
  margin-top: 5px;
  //margin-bottom: 20px;
`;

const Position = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  margin: 0 0 10px 0;
`;

const DelButton = styled(Button)`
  margin-top: 5px;
  //margin-bottom: 20px;
`;

const SmallInputContainer = styled.div`
  display: flex;
  width: auto;
  margin: 0 5px 0 0; 
`;

const SmallInputBox = styled(SmallInput)`
  width: 104px;
  padding: 0 14px 0 0;
  border-radius: 3px;
  outline: none;
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 12px;
  color: #767676;
  margin-top: -5px;
  
  margin-bottom: -20px;
`;

const InputHeader = styled.label`
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.35px;
  color: #7f7f7f;
  margin-bottom: 7px;
`;

const InputField = styled.div`
  display: flex;
  flex-direction: column;
`;

const FieldLabel = styled(Label)`
  height: 10px;
  margin: 2px 0 8px 2px;
  font-size: 12px;
  color: #767676;
  white-space: nowrap;
`;

const EmptyBox = styled.label`
  margin-bottom: 55px;
`;

const jobStartTypeTemplate = [
  ['全身姿勢', '右手姿勢', '左手姿勢', '身体部位位置'],
  ['PoseCategory', 'RightHandCategory', 'LeftHandCategory', 'BodyParts']
];
const jobEndTypeTemplate = [
  ['全身姿勢', '右手姿勢', '左手姿勢', '身体部位位置', '次のジョブが開始'],
  ['PoseCategory', 'RightHandCategory', 'LeftHandCategory', 'BodyParts', 'NextJobStart']
];
const state_bodyParts = [
  ['鼻位置', '左手', '右手', '左肩', '右肩', '左腹', '右腹', '左膝', '右膝', '左足', '右足'],
  ['nose', 'left_index', 'right_index', 'left_shoulder', 'right_shoulder', 'left_hip', 'right_hip', 'left_knee', 'right_knee', 'left_foot_index', 'right_foot_index'],
];

const PlaceCameras = () => {
  const { t } = useTranslation(['SetupCameras', 'Common']);
  const [validationAlert, setValidationAlert] = useState<{ key?: any, message: string, type: 'success' | 'error' | 'warning' | 'info' | undefined }>({ key: new Date(), message: '', type: undefined });

  const { completedStep, setSelectedStep, setCompletedStep} = useContext(MenuContext);
  const { pathUpdated } = useContext(PathContext);

  const { floorPlanStorage, setFloorPlanStorage } = useLocalStorage();
  const [ selectedJob, setSelectedJob ] = useState(0);

  const [ state_jobStartType ] = useState(jobStartTypeTemplate);
  const [ state_jobEndType ] = useState(jobEndTypeTemplate);

 
  const newJobTemplate = {
    'id': 0,
    'name': 'jobName0',
    'type': 'single',
    'job_start': {
      'type': ['PoseCategory'],
      'pose_category' : floorPlanStorage.BodyCategorylist[0],
      'pose_category_threshold' : 6,
      'pose_category_time' : 0,
    
      'right_hand_category' : floorPlanStorage.HandCategorylist[0],
      'right_hand_category_threshold' : 7,
      'right_hand_category_time' : 1,
    
      'left_hand_category' : floorPlanStorage.HandCategorylist[0],
      'left_hand_category_threshold' : 8,
      'left_hand_category_time' : 2,
    
      'body_parts' : 'nose',
      'body_area_id' : 0,
      'body_parts_time' : 3
    },
    'job_end': {
      'type': ['PoseCategory'],
      'pose_category' : floorPlanStorage.BodyCategorylist[0],
      'pose_category_threshold' : 6,
      'pose_category_time' : 0,
    
      'right_hand_category' : floorPlanStorage.HandCategorylist[0],
      'right_hand_category_threshold' : 7,
      'right_hand_category_time' : 1,
    
      'left_hand_category' : floorPlanStorage.HandCategorylist[0],
      'left_hand_category_threshold' : 8,
      'left_hand_category_time' : 2,
    
      'body_parts' : 'nose',
      'body_area_id' : 0,
      'body_parts_time' : 3
    }
  };
  const [ jobs, setJobs ] = useState(floorPlanStorage.jobs.length !== 0 ? floorPlanStorage.jobs : [JSON.parse(JSON.stringify(newJobTemplate))]);

  const [ maxJobID, setMaxJobID ] = useState(floorPlanStorage.maxJobID ? floorPlanStorage.maxJobID : 0);
  
  
  //ジョブ追加
  const addJob = useCallback(() => {
    const newjobs = {
      'id': maxJobID + 1,
      'name': 'jobName' + (maxJobID + 1),
      'type': 'single',
      'job_start': {
        'type': ['PoseCategory'],
        'pose_category' : floorPlanStorage.BodyCategorylist[0],
        'pose_category_threshold' : 6,
        'pose_category_time' : 0,
      
        'right_hand_category' : floorPlanStorage.HandCategorylist[0],
        'right_hand_category_threshold' : 7,
        'right_hand_category_time' : 1,
      
        'left_hand_category' : floorPlanStorage.HandCategorylist[0],
        'left_hand_category_threshold' : 8,
        'left_hand_category_time' : 2,
      
        'body_parts' : 'nose',
        'body_area_id' : 0,
        'body_parts_time' : 3
      },
      'job_end': {
        'type': ['PoseCategory'],
        'pose_category' : floorPlanStorage.BodyCategorylist[0],
        'pose_category_threshold' : 6,
        'pose_category_time' : 0,
      
        'right_hand_category' : floorPlanStorage.HandCategorylist[0],
        'right_hand_category_threshold' : 7,
        'right_hand_category_time' : 1,
      
        'left_hand_category' : floorPlanStorage.HandCategorylist[0],
        'left_hand_category_threshold' : 8,
        'left_hand_category_time' : 2,
      
        'body_parts' : 'nose',
        'body_area_id' : 0,
        'body_parts_time' : 3
      }
    };

    //nameに重複しているかどうかチェック
    const nameList = [];
    for(let i = 0; i < jobs.length; i++) {//既存name取得
      nameList.push(jobs[i].name);
    }
    if (nameList.indexOf('jobName' + (maxJobID + 1)) !== -1){
      newjobs.name = '_jobName' + (maxJobID + 1);
    }

    setJobs([...jobs, newjobs]);
    setSelectedJob(jobs.length);
    setMaxJobID(maxJobID + 1);
    setCompletedStep(13);
  }, [maxJobID, jobs, floorPlanStorage, setCompletedStep]);

  //ジョブ削除
  const delJob = useCallback(() => {
    if (jobs.length === 1) {
      return false;
    }
    
    //jobを削除したら,taskとの関連付けも削除
    if (floorPlanStorage.tasks){
      const newtasks = JSON.parse(JSON.stringify(floorPlanStorage.tasks));
      for (let i = newtasks.length-1; i >= 0; i--) {
        for (let index = newtasks[i].jobList.length-1; index >= 0; index--){
          if (newtasks[i].jobList[index].id === jobs[selectedJob].id){
            newtasks[i].jobList.splice(index, 1);
          }
        }
      }
      setFloorPlanStorage({tasks: newtasks});
    }
    //taskが変更されたら,tasksetと関連付け済みのtaskも変更
    if (floorPlanStorage.tasksets){
      const newtasksets = JSON.parse(JSON.stringify(floorPlanStorage.tasksets));
      for (let i = 0; i < newtasksets.length; i++) {
        for (let k = 0; k < newtasksets[i].taskList.length; k++) {

          for (let n = 0; n < newtasksets[i].taskList[k].jobList.length; n++) {
            if (newtasksets[i].taskList[k].jobList[n].id === jobs[selectedJob].id){
              newtasksets[i].taskList[k].jobList.splice(n, 1);
            }
          }
        }
      }
      setFloorPlanStorage({tasksets: newtasksets});
    }
    
    const newjobs = [...jobs];
    newjobs.splice(selectedJob, 1);
    setJobs(newjobs);
    setSelectedJob(0);
    setCompletedStep(13);
  }, [jobs, selectedJob, floorPlanStorage, setFloorPlanStorage, setCompletedStep]);

  //starttpye追加
  const addStartType = useCallback(() => {
    const newjobs = [...jobs];
    for(const i in state_jobStartType[1]){
      if (newjobs[selectedJob].job_start.type.indexOf(state_jobStartType[1][i]) === -1){
        newjobs[selectedJob].job_start.type.push(state_jobStartType[1][i]);
        break;
      }
    }
    setJobs(newjobs);
    setCompletedStep(13);
  }, [jobs, selectedJob, state_jobStartType, setCompletedStep]);
  //starttpye削除
  const delStartType = useCallback((index) => {
    if (jobs[selectedJob].job_start.type.length === 1) {
      return false;
    }

    const newjobs = [...jobs];
    newjobs[selectedJob].job_start.type.splice(index, 1);
    setJobs(newjobs);
    setCompletedStep(13);
  }, [jobs, selectedJob, setCompletedStep]);

  
  //endtpye追加
  const addEndType = useCallback(() => {
    const newjobs = [...jobs];
    for(const i in state_jobEndType[1]){
      if (newjobs[selectedJob].job_end.type.indexOf(state_jobEndType[1][i]) === -1){
        newjobs[selectedJob].job_end.type.push(state_jobEndType[1][i]);
        break;
      }
    }
    setJobs(newjobs);
    setCompletedStep(13);
  }, [jobs, selectedJob, state_jobEndType, setCompletedStep]);
  //endtpye削除
  const delEndType = useCallback((index) => {
    if (jobs[selectedJob].job_end.type.length === 1) {
      return false;
    }

    const newjobs = [...jobs];
    newjobs[selectedJob].job_end.type.splice(index, 1);
    setJobs(newjobs);
    setCompletedStep(13);
  }, [jobs, selectedJob, setCompletedStep]);

  //今設定中のjobIDを取得
  const getSelectedJob = useCallback((ev) => {
    for(let i=0; i<jobs.length; i++) {
      if(jobs[i].name === ev.target.value) {
        setSelectedJob(i);
        break;
      }
    }
  }, [jobs]);

  //ジョブ名変更
  const renameJob = useCallback((ev) => {
    const newname = ev.target.value;
    //同名判定
    for(const i in jobs){
      if(jobs[i].name === newname) {
        setValidationAlert({ key: new Date(), message: '同名のジョブが存在しております。ジョブ名：' + newname, type: 'error' });
        return;
      }
    }

    //job名変更したら,taskと関連付け済みのjobも変更
    if (floorPlanStorage.tasks){
      const newtasks = JSON.parse(JSON.stringify(floorPlanStorage.tasks));
      for (let i = newtasks.length-1; i >= 0; i--) {
        for (let index = newtasks[i].jobList.length-1; index >= 0; index--){
          if (newtasks[i].jobList[index].id === jobs[selectedJob].id){
            newtasks[i].jobList[index].name = newname;
          }
        }
      }
      setFloorPlanStorage({tasks: newtasks});
    }
    //job名変更したら,tasksetsと関連付け済みのjobも変更
    if (floorPlanStorage.tasksets){
      const newtasksets = JSON.parse(JSON.stringify(floorPlanStorage.tasksets));
      for (let i = 0; i < newtasksets.length; i++) {
        for (let k = 0; k < newtasksets[i].taskList.length; k++){
          for (let n = 0; n < newtasksets[i].taskList[k].jobList.length; n++){
            if (newtasksets[i].taskList[k].jobList[n].id === jobs[selectedJob].id){
              newtasksets[i].taskList[k].jobList[n].name = newname;
            }
          }
        }
      }
      setFloorPlanStorage({tasksets: newtasksets});
    }

    const newjobs = [...jobs];
    newjobs[selectedJob].name = newname;
    setJobs(newjobs);
    setCompletedStep(13);
  }, [jobs, selectedJob, floorPlanStorage, setFloorPlanStorage, setCompletedStep]);

  //ジョブ属性変更、一度だけのjobか、繰り返し利用できるjobか
  /*const changeJobType = useCallback((ev) => {
    const newjobs = [...jobs];
    newjobs[selectedJob].type = ev.target.value;
    setJobs(newjobs);
    setCompletedStep(13);
  }, [jobs, selectedJob, setCompletedStep]);*/
  
  
  
  /*---------StartType---------*/
  //ジョブStartType変更
  const changeStartType = useCallback(({ target: { value } }, index) => {
    const newjobs = [...jobs];
    //state_jobStartType[0]:表示漢字、state_jobStartType[1]json保存用英語
    switch(value){
    case state_jobStartType[0][0]:
      newjobs[selectedJob].job_start.type[index] = state_jobStartType[1][0];
      break;
    case state_jobStartType[0][1]:
      newjobs[selectedJob].job_start.type[index] = state_jobStartType[1][1];
      break;
    case state_jobStartType[0][2]:
      newjobs[selectedJob].job_start.type[index] = state_jobStartType[1][2];
      break;
    case state_jobStartType[0][3]:
      newjobs[selectedJob].job_start.type[index] = state_jobStartType[1][3];
      break;
    }
    setJobs(newjobs);
    setCompletedStep(13);
  }, [jobs, selectedJob, state_jobStartType, setCompletedStep]);
  //ジョブStartOption1変更：ポーズカテゴリーor部位
  const changeStartOption1 = useCallback(({ target: { value } }, type) => {
    const newjobs = [...jobs];
    switch(type){
    case 'PoseCategory':
      newjobs[selectedJob].job_start.pose_category = value;
      break;
    case 'RightHandCategory':
      newjobs[selectedJob].job_start.right_hand_category = value;
      break;
    case 'LeftHandCategory':
      newjobs[selectedJob].job_start.left_hand_category = value;
      break;
    case 'BodyParts':
      newjobs[selectedJob].job_start.body_parts = state_bodyParts[1][state_bodyParts[0].indexOf(value)];
      break;
    }
    setJobs(newjobs);
    setCompletedStep(13);
  }, [jobs, selectedJob, setCompletedStep]);
  //ジョブStartOption2変更:閾値orエリア
  const changeStartOption2 = useCallback(({ target: { value } }, type) => {
    if (type !== 'BodyParts' ) {
      if ( isNaN(Number(value)) ) return;
      if ( value > 10 || value < 0 ) return;
    }
    
    const newjobs = [...jobs];
    switch(type){
    case 'PoseCategory':
      newjobs[selectedJob].job_start.pose_category_threshold = Number(value);
      break;
    case 'RightHandCategory':
      newjobs[selectedJob].job_start.right_hand_category_threshold = Number(value);
      break;
    case 'LeftHandCategory':
      newjobs[selectedJob].job_start.left_hand_category_threshold = Number(value);
      break;
    case 'BodyParts':
      for (let i = 0; i < floorPlanStorage.BodyAreas.length; i++) {
        if (floorPlanStorage.BodyAreas[i].data.name === value){
          newjobs[selectedJob].job_start.body_area_id = floorPlanStorage.BodyAreas[i].id;
          break;
        }
      }
      break;
    }
    setJobs(newjobs);
    setCompletedStep(13);
  }, [jobs, selectedJob, floorPlanStorage.BodyAreas, setCompletedStep]);
  //ジョブStartOption3変更:継続秒数
  const changeStartOption3 = useCallback(({ target: { value } }, type) => {
    if ( isNaN(Number(value)) ) return;
    if ( value > 10 || value < 0 ) return;

    const newjobs = [...jobs];
    switch(type){
    case 'PoseCategory':
      newjobs[selectedJob].job_start.pose_category_time = Number(value);
      break;
    case 'RightHandCategory':
      newjobs[selectedJob].job_start.right_hand_category_time = Number(value);
      break;
    case 'LeftHandCategory':
      newjobs[selectedJob].job_start.left_hand_category_time = Number(value);
      break;
    case 'BodyParts':
      newjobs[selectedJob].job_start.body_parts_time = Number(value);
      break;
    }
    setJobs(newjobs);
    setCompletedStep(13);
  }, [jobs, selectedJob, setCompletedStep]);

  
  /*---------EndType---------*/
  //ジョブEndType変更
  const changeEndType = useCallback(({ target: { value } }, index) => {
    const newjobs = [...jobs];
    //state_jobEndType[0]:表示漢字、state_jobEndType[1]json保存用英語
    switch(value){
    case state_jobEndType[0][0]:
      newjobs[selectedJob].job_end.type[index] = state_jobEndType[1][0];
      break;
    case state_jobEndType[0][1]:
      newjobs[selectedJob].job_end.type[index] = state_jobEndType[1][1];
      break;
    case state_jobEndType[0][2]:
      newjobs[selectedJob].job_end.type[index] = state_jobEndType[1][2];
      break;
    case state_jobEndType[0][3]:
      newjobs[selectedJob].job_end.type[index] = state_jobEndType[1][3];
      break;
    case state_jobEndType[0][4]:
      newjobs[selectedJob].job_end.type[index] = state_jobEndType[1][4];
      break;
    case state_jobEndType[0][5]:
      newjobs[selectedJob].job_end.type[index] = state_jobEndType[1][5];
      break;
    }
    setJobs(newjobs);
    setCompletedStep(13);
  }, [jobs, selectedJob, state_jobEndType, setCompletedStep]);
  //ジョブEndOption1変更：ポーズカテゴリーor部位
  const changeEndOption1 = useCallback(({ target: { value } }, type) => {
    const newjobs = [...jobs];
    switch(type){
    case 'PoseCategory':
      newjobs[selectedJob].job_end.pose_category = value;
      break;
    case 'RightHandCategory':
      newjobs[selectedJob].job_end.right_hand_category = value;
      break;
    case 'LeftHandCategory':
      newjobs[selectedJob].job_end.left_hand_category = value;
      break;
    case 'BodyParts':
      newjobs[selectedJob].job_end.body_parts = state_bodyParts[1][state_bodyParts[0].indexOf(value)];
      break;
    }
    setJobs(newjobs);
    setCompletedStep(13);
  }, [jobs, selectedJob, setCompletedStep]);
  //ジョブEndOption2変更:閾値orエリア
  const changeEndOption2 = useCallback(({ target: { value } }, type) => {
    if (type !== 'BodyParts' ) {
      if ( isNaN(Number(value)) ) return;
      if ( value > 10 || value < 0 ) return;
    }

    const newjobs = [...jobs];
    switch(type){
    case 'PoseCategory':
      newjobs[selectedJob].job_end.pose_category_threshold = Number(value);
      break;
    case 'RightHandCategory':
      newjobs[selectedJob].job_end.right_hand_category_threshold = Number(value);
      break;
    case 'LeftHandCategory':
      newjobs[selectedJob].job_end.left_hand_category_threshold = Number(value);
      break;
    case 'BodyParts':
      for (let i = 0; i < floorPlanStorage.BodyAreas.length; i++) {
        if (floorPlanStorage.BodyAreas[i].data.name === value){
          newjobs[selectedJob].job_end.body_area_id = floorPlanStorage.BodyAreas[i].id;
          break;
        }
      }
      break;
    }
    setJobs(newjobs);
    setCompletedStep(13);
  }, [jobs, selectedJob, floorPlanStorage.BodyAreas, setCompletedStep]);
  //ジョブEndOption3変更:継続秒数
  const changeEndOption3 = useCallback(({ target: { value } }, type) => {
    if ( isNaN(Number(value)) ) return;
    if ( value > 10 || value < 0 ) return;

    const newjobs = [...jobs];
    switch(type){
    case 'PoseCategory':
      newjobs[selectedJob].job_end.pose_category_time = Number(value);
      break;
    case 'RightHandCategory':
      newjobs[selectedJob].job_end.right_hand_category_time = Number(value);
      break;
    case 'LeftHandCategory':
      newjobs[selectedJob].job_end.left_hand_category_time = Number(value);
      break;
    case 'BodyParts':
      newjobs[selectedJob].job_end.body_parts_time = Number(value);
      break;
    }
    setJobs(newjobs);
    setCompletedStep(13);
  }, [jobs, selectedJob, setCompletedStep]);
  

  /*---------route---------*/
  const onContinue = useCallback((index: number) => {
    for (let i=0; i < jobs.length; i++) {
      if (jobs[i].job_end.type.length === 0 ){
        setValidationAlert({ key: new Date(), message: '停止設定が漏れているジョブがあります。正しく設定してください。', type: 'error' });
        return;
      }
      if (jobs[i].job_start.type.length === 0 ){
        setValidationAlert({ key: new Date(), message: '開始設定が漏れているジョブがあります。正しく設定してください。', type: 'error' });
        return;
      }
    }

    setFloorPlanStorage({jobs});
    setFloorPlanStorage({maxJobID});
    setSelectedStep(index);
    setCompletedStep(completedStep > 13 ? completedStep : 13);
  }, [maxJobID, jobs, completedStep, setCompletedStep, setSelectedStep, setFloorPlanStorage]);

  useEffect(() => {
    if (pathUpdated) { setSelectedStep(13); }
  }, [setSelectedStep, pathUpdated]);
  /*---------route---------*/
  return (
    <Container>
      <HeaderContainer>
        <PageHeader title='ジョブ設定' areaHref='/' areaTitle={floorPlanStorage.completed_step === 999 ? '初期設定': '設定編集'} />
        <Buttons>
          <BackButton size='small' design='secondary' onClick={() => onContinue(12)}>{t('Common:back')}</BackButton>
          <Button design='primary' size='small' onClick={() => onContinue(14)}>{t('Common:next')}</Button>
        </Buttons>
      </HeaderContainer>

      {validationAlert.message !== '' &&
        <ValidationAlert type={validationAlert.type} message={validationAlert.message} />}

      <InputContainer>
        <AreaInfo>
          <InputHeader>ジョブ追加</InputHeader>
          <SmallInputContainer>
            <InputField>
              <Button design='primary' size='small' onClick={addJob}>ADD</Button>
            </InputField>
          </SmallInputContainer>
        </AreaInfo>
        <AreaInfo>
          <InputHeader>編集するジョブを選択</InputHeader>
          <SmallInputContainer>
            <InputField>
              <SelectFieldBox value={jobs[selectedJob].name} onChange={getSelectedJob}>
                {jobs.map((job: any)=>{
                  return <option key={'select_job_'+job.id} value={job.name}>{job.name}</option>;
                })}
              </SelectFieldBox>
            </InputField>
          </SmallInputContainer>
        </AreaInfo>
        <AreaInfo>
          <InputHeader>ジョブ名設定</InputHeader>
          <SmallInputContainer>
            <InputField>
              <SmallInputBox label='' value={jobs[selectedJob].name} onChange={renameJob} />
            </InputField>
          </SmallInputContainer>
        </AreaInfo>
        {/*<AreaInfo>
          <InputHeader>ジョブ属性設定</InputHeader>
          <SmallInputContainer>
            <InputField>
              <SelectFieldBox value={jobs[selectedJob].type} onChange={changeJobType}>
                <option value='single'>single</option>
                <option value='repeatable'>repeatable</option>
              </SelectFieldBox>
            </InputField>
          </SmallInputContainer>
        </AreaInfo>*/}
        <AreaInfo>
          <InputHeader>ジョブ削除</InputHeader>
          <SmallInputContainer>
            <InputField>
              <Button design='primary' size='small' onClick={delJob}>DEL</Button>
            </InputField>
          </SmallInputContainer>
        </AreaInfo>
      </InputContainer>

      {/* start type 設定*/}
      <StartTypeContainer>
        <Position>
          <InputHeader>開始判定種別</InputHeader>
          <SmallInputContainer>
            <InputField>
              {jobs[selectedJob].job_start.type.map((startType: any, i)=>{
                const index = state_jobStartType[1].indexOf(startType);
                return (
                  <>
                    <FieldLabel htmlFor='' labelText='種別選択' />
                    <SelectFieldBox key={'jobStartType_'+selectedJob+i} value={state_jobStartType[0][index]} onChange={(event) => changeStartType(event, i)}>
                      {state_jobStartType[0].map((item: any, k)=>{
                        if (jobs[selectedJob].job_start.type.indexOf(state_jobStartType[1][k]) === -1 || startType === state_jobStartType[1][k]){
                          return <option key={'jobStartType_'+startType+selectedJob+i+k} value={item}>{item}</option>;
                        }else{
                          return <></>;
                        }
                      })}
                    </SelectFieldBox>
                  </>);
              })}
            </InputField>
          </SmallInputContainer>
        </Position>
        <Position>
          <InputHeader>設定項目1</InputHeader>
          <SmallInputContainer>
            <InputField>
              {jobs[selectedJob].job_start.type.map((startType: any, i)=>{
                if (startType === 'PoseCategory'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='全身姿勢名' />
                      <SelectFieldBox key={'PoseCategoryOption1_'+startType+selectedJob+i} defaultValue={jobs[selectedJob].job_start.pose_category} onChange={(event) => changeStartOption1(event, startType)}>
                        {floorPlanStorage.BodyCategorylist.map((PoseCategory: any, k)=>{
                          return <option key={'PoseCategoryOption1_'+startType+selectedJob+i+k} value={PoseCategory}>{PoseCategory}</option>;
                        })}
                      </SelectFieldBox>
                    </>);
                }else if (startType === 'RightHandCategory'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='右手姿勢名' />
                      <SelectFieldBox key={'PoseCategoryOption1_'+startType+selectedJob+i} defaultValue={jobs[selectedJob].job_start.right_hand_category} onChange={(event) => changeStartOption1(event, startType)}>
                        {floorPlanStorage.HandCategorylist.map((rightHandCategory: any, k)=>{
                          return <option key={'PoseCategoryOption1_'+startType+selectedJob+i+k} value={rightHandCategory}>{rightHandCategory}</option>;
                        })}
                      </SelectFieldBox>
                    </>);
                }else if (startType === 'LeftHandCategory'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='左手姿勢名' />
                      <SelectFieldBox key={'PoseCategoryOption1_'+startType+selectedJob+i} defaultValue={jobs[selectedJob].job_start.left_hand_category} onChange={(event) => changeStartOption1(event, startType)}>
                        {floorPlanStorage.HandCategorylist.map((leftHandCategory: any, k)=>{
                          return <option key={'PoseCategoryOption1_'+startType+selectedJob+i+k} value={leftHandCategory}>{leftHandCategory}</option>;
                        })}
                      </SelectFieldBox>
                    </>);
                }else if (startType === 'BodyParts'){
                  const defaultValue_startBodyParts_1 = state_bodyParts[0][state_bodyParts[1].indexOf(jobs[selectedJob].job_start.body_parts)];
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='身体部位位置' />
                      <SelectFieldBox key={'PoseCategoryOption1_'+startType+selectedJob+i} defaultValue={defaultValue_startBodyParts_1} onChange={(event) => changeStartOption1(event, startType)}>
                        {state_bodyParts[0].map((bodyPart: any, k)=>{
                          return <option key={'PoseCategoryOption1_'+startType+selectedJob+i+k} value={bodyPart}>{bodyPart}</option>;
                        })}
                      </SelectFieldBox>
                    </>);
                }
                return false;
              })}
            </InputField>
          </SmallInputContainer>
        </Position>
        <Position>
          <InputHeader>設定項目2</InputHeader>
          <SmallInputContainer>
            <InputField>
              {jobs[selectedJob].job_start.type.map((startType: any, i)=>{
                if (startType === 'PoseCategory'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='姿勢判定閾値' />
                      <SmallInputBox
                        key={'PoseCategory_threshold'+startType+selectedJob+i} label=''
                        value={jobs[selectedJob].job_start.pose_category_threshold}
                        onChange={(event) => changeStartOption2(event, startType)}
                      />
                    </>);
                }else if (startType === 'RightHandCategory'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='姿勢判定閾値' />
                      <SmallInputBox
                        key={'righthandcategory_threshold'+startType+selectedJob+i} label=''
                        value={jobs[selectedJob].job_start.right_hand_category_threshold}
                        onChange={(event) => changeStartOption2(event, startType)}
                      />
                    </>);
                }else if (startType === 'LeftHandCategory'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='姿勢判定閾値' />
                      <SmallInputBox
                        key={'lefthandcategory_threshold'+startType+selectedJob+i} label=''
                        value={jobs[selectedJob].job_start.left_hand_category_threshold}
                        onChange={(event) => changeStartOption2(event, startType)}
                      />
                    </>);
                }else if (startType === 'BodyParts'){
                  let defaultValue_startBodyParts_2 = '';
                  for (let i = 0; i < floorPlanStorage.BodyAreas.length; i++){
                    if (floorPlanStorage.BodyAreas[i].id === jobs[selectedJob].job_start.body_area_id){
                      defaultValue_startBodyParts_2 = floorPlanStorage.BodyAreas[i].data.name;
                      break;
                    }
                  }
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='指定エリア' />
                      <SelectFieldBox key={'bodyparts'+startType+selectedJob+i} defaultValue={defaultValue_startBodyParts_2} onChange={(event) => changeStartOption2(event, startType)}>
                        {floorPlanStorage.BodyAreas.map((BodyArea: any, k)=>{
                          return <option key={'bodyparts'+startType+selectedJob+i+k} value={BodyArea.data.name}>{BodyArea.data.name}</option>;
                        })}
                      </SelectFieldBox>
                    </>);
                }
                return false;
              })}
            </InputField>
          </SmallInputContainer>
        </Position>
        <Position>
          <InputHeader>設定項目3</InputHeader>
          <SmallInputContainer>
            <InputField>
              {jobs[selectedJob].job_start.type.map((startType: any, i)=>{
                if (startType === 'PoseCategory'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='継続秒数' />
                      <SmallInputBox
                        key={'time_'+startType+selectedJob+i} label=''
                        value={jobs[selectedJob].job_start.pose_category_time}
                        onChange={(event) => changeStartOption3(event, startType)}
                      />
                    </>);
                }else if (startType === 'RightHandCategory'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='継続秒数' />
                      <SmallInputBox
                        key={'time_'+startType+selectedJob+i} label=''
                        value={jobs[selectedJob].job_start.right_hand_category_time}
                        onChange={(event) => changeStartOption3(event, startType)}
                      />
                    </>);
                }else if (startType === 'LeftHandCategory'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='継続秒数' />
                      <SmallInputBox
                        key={'time_'+startType+selectedJob+i} label=''
                        value={jobs[selectedJob].job_start.left_hand_category_time}
                        onChange={(event) => changeStartOption3(event, startType)}
                      />
                    </>);
                }else if (startType === 'BodyParts'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='エリア内滞在秒数' />
                      <SmallInputBox
                        key={'time_'+startType+selectedJob+i} label=''
                        value={jobs[selectedJob].job_start.body_parts_time}
                        onChange={(event) => changeStartOption3(event, startType)}
                      />
                    </>);
                }
                return false;
              })}
            </InputField>
          </SmallInputContainer>
        </Position>

        <Position>
          <InputHeader>操作</InputHeader>
          {jobs[selectedJob].job_start.type.map((startType: any, i)=>{
            return (
              <SmallInputContainer key={'del_'+startType+selectedJob+i}>
                <InputField>
                  <FieldLabel htmlFor='' labelText='削除' />
                  <DelButton key={'delbtn_'+startType+selectedJob+i} size='small' design='primary' onClick={() => delStartType(i)}>－</DelButton>
                </InputField>
              </SmallInputContainer>);
          })}
          <SmallInputContainer>
            {jobs[selectedJob].job_start.type.length < 4 ?
              <>
                <InputField>
                  <FieldLabel htmlFor='' labelText='追加' />
                  <DelButton size='small' design='primary' onClick={addStartType}>＋</DelButton>
                </InputField>
              </>
              :<></>}
          </SmallInputContainer>
        </Position>
      </StartTypeContainer>


      {/* end type 設定*/}
      <EndTypeContainer>
        <Position>
          <InputHeader>終了判定種別</InputHeader>
          <SmallInputContainer>
            <InputField>
              {jobs[selectedJob].job_end.type.map((endType: any, i)=>{
                const index = state_jobEndType[1].indexOf(endType);
                return (
                  <>
                    <FieldLabel htmlFor='' labelText='種別選択' />
                    <SelectFieldBox key={'jobEndType_'+selectedJob+i} value={state_jobEndType[0][index]} onChange={(event) => changeEndType(event, i)}>
                      {state_jobEndType[0].map((item: any, k)=>{
                        if (jobs[selectedJob].job_end.type.indexOf(state_jobEndType[1][k]) === -1 || endType === state_jobEndType[1][k]){
                          return <option key={'jobEndType_'+endType+selectedJob+i+k} value={item}>{item}</option>;
                        }else{
                          return <></>;
                        }
                      })}
                    </SelectFieldBox>
                  </>);
              })}
            </InputField>
          </SmallInputContainer>
        </Position>
        <Position>
          <InputHeader>設定項目1</InputHeader>
          <SmallInputContainer>
            <InputField>
              {jobs[selectedJob].job_end.type.map((endType: any, i)=>{
                if (endType === 'PoseCategory'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='全身姿勢名' />
                      <SelectFieldBox key={'PoseCategoryOption1_'+endType+selectedJob+i} defaultValue={jobs[selectedJob].job_end.pose_category} onChange={(event) => changeEndOption1(event, endType)}>
                        {floorPlanStorage.BodyCategorylist.map((PoseCategory: any, k)=>{
                          return <option key={'PoseCategoryOption1_'+endType+selectedJob+i+k} value={PoseCategory}>{PoseCategory}</option>;
                        })}
                      </SelectFieldBox>
                    </>);
                }else if (endType === 'RightHandCategory'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='右手姿勢名' />
                      <SelectFieldBox key={'PoseCategoryOption1_'+endType+selectedJob+i} defaultValue={jobs[selectedJob].job_end.right_hand_category} onChange={(event) => changeEndOption1(event, endType)}>
                        {floorPlanStorage.HandCategorylist.map((rightHandCategory: any, k)=>{
                          return <option key={'PoseCategoryOption1_'+endType+selectedJob+i+k} value={rightHandCategory}>{rightHandCategory}</option>;
                        })}
                      </SelectFieldBox>
                    </>);
                }else if (endType === 'LeftHandCategory'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='左手姿勢名' />
                      <SelectFieldBox key={'PoseCategoryOption1_'+endType+selectedJob+i} defaultValue={jobs[selectedJob].job_end.left_hand_category} onChange={(event) => changeEndOption1(event, endType)}>
                        {floorPlanStorage.HandCategorylist.map((leftHandCategory: any, k)=>{
                          return <option key={'PoseCategoryOption1_'+endType+selectedJob+i+k} value={leftHandCategory}>{leftHandCategory}</option>;
                        })}
                      </SelectFieldBox>
                    </>);
                }else if (endType === 'BodyParts'){
                  const defaultValue_endBodyParts_1 = state_bodyParts[0][state_bodyParts[1].indexOf(jobs[selectedJob].job_end.body_parts)];
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='身体部位位置' />
                      <SelectFieldBox key={'PoseCategoryOption1_'+endType+selectedJob+i} defaultValue={defaultValue_endBodyParts_1} onChange={(event) => changeEndOption1(event, endType)}>
                        {state_bodyParts[0].map((bodyPart: any, k)=>{
                          return <option key={'PoseCategoryOption1_'+endType+selectedJob+i+k} value={bodyPart}>{bodyPart}</option>;
                        })}
                      </SelectFieldBox>
                    </>);
                }else if (endType === 'NextJobStart'){
                  return <EmptyBox />;
                }
                
                return false;
              })}
            </InputField>
          </SmallInputContainer>
        </Position>
        <Position>
          <InputHeader>設定項目2</InputHeader>
          <SmallInputContainer>
            <InputField>
              {jobs[selectedJob].job_end.type.map((endType: any, i)=>{
                if (endType === 'PoseCategory'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='姿勢判定閾値' />
                      <SmallInputBox
                        key={'PoseCategory_threshold'+endType+selectedJob+i} label=''
                        value={jobs[selectedJob].job_end.pose_category_threshold}
                        onChange={(event) => changeEndOption2(event, endType)}
                      />
                    </>);
                }else if (endType === 'RightHandCategory'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='姿勢判定閾値' />
                      <SmallInputBox
                        key={'righthandcategory_threshold'+endType+selectedJob+i} label=''
                        value={jobs[selectedJob].job_end.right_hand_category_threshold}
                        onChange={(event) => changeEndOption2(event, endType)}
                      />
                    </>);
                }else if (endType === 'LeftHandCategory'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='姿勢判定閾値' />
                      <SmallInputBox
                        key={'lefthandcategory_threshold'+endType+selectedJob+i} label=''
                        value={jobs[selectedJob].job_end.left_hand_category_threshold}
                        onChange={(event) => changeEndOption2(event, endType)}
                      />
                    </>);
                }else if (endType === 'BodyParts'){
                  let defaultValue_endBodyParts_2 = '';
                  for (let i = 0; i < floorPlanStorage.BodyAreas.length; i++){
                    if (floorPlanStorage.BodyAreas[i].id === jobs[selectedJob].job_end.body_area_id){
                      defaultValue_endBodyParts_2 = floorPlanStorage.BodyAreas[i].data.name;
                      break;
                    }
                  }
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='指定エリア' />
                      <SelectFieldBox key={'bodyparts'+endType+selectedJob+i} defaultValue={defaultValue_endBodyParts_2} onChange={(event) => changeEndOption2(event, endType)}>
                        {floorPlanStorage.BodyAreas.map((BodyArea: any, k)=>{
                          return <option key={'bodyparts'+endType+selectedJob+i+k} value={BodyArea.data.name}>{BodyArea.data.name}</option>;
                        })}
                      </SelectFieldBox>
                    </>);
                }else if (endType === 'NextJobStart'){
                  return <EmptyBox />;
                }
                return false;
              })}
            </InputField>
          </SmallInputContainer>
        </Position>
        <Position>
          <InputHeader>設定項目3</InputHeader>
          <SmallInputContainer>
            <InputField>
              {jobs[selectedJob].job_end.type.map((endType: any, i)=>{
                if (endType === 'PoseCategory'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='継続秒数' />
                      <SmallInputBox
                        key={'time_'+endType+selectedJob+i} label=''
                        value={jobs[selectedJob].job_end.pose_category_time}
                        onChange={(event) => changeEndOption3(event, endType)}
                      />
                    </>);
                }else if (endType === 'RightHandCategory'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='継続秒数' />
                      <SmallInputBox
                        key={'time_'+endType+selectedJob+i} label=''
                        value={jobs[selectedJob].job_end.right_hand_category_time}
                        onChange={(event) => changeEndOption3(event, endType)}
                      />
                    </>);
                }else if (endType === 'LeftHandCategory'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='継続秒数' />
                      <SmallInputBox
                        key={'time_'+endType+selectedJob+i} label=''
                        value={jobs[selectedJob].job_end.left_hand_category_time}
                        onChange={(event) => changeEndOption3(event, endType)}
                      />
                    </>);
                }else if (endType === 'BodyParts'){
                  return (
                    <>
                      <FieldLabel htmlFor='' labelText='エリア内滞在秒数' />
                      <SmallInputBox
                        key={'time_'+endType+selectedJob+i} label=''
                        value={jobs[selectedJob].job_end.body_parts_time}
                        onChange={(event) => changeEndOption3(event, endType)}
                      />
                    </>);
                }else if (endType === 'NextJobStart'){
                  return <EmptyBox />;
                }
                return false;
              })}
            </InputField>
          </SmallInputContainer>
        </Position>

        <Position>
          <InputHeader>操作</InputHeader>
          {jobs[selectedJob].job_end.type.map((endType: any, i)=>{
            return (
              <SmallInputContainer key={'del_'+endType+selectedJob+i}>
                <InputField>
                  <FieldLabel htmlFor='' labelText='削除' />
                  <DelButton key={'delbtn_'+endType+selectedJob+i} size='small' design='primary' onClick={() => delEndType(i)}>－</DelButton>
                </InputField>
              </SmallInputContainer>);
          })}
          <SmallInputContainer>
            {jobs[selectedJob].job_end.type.length < 5 ?
              <>
                <InputField>
                  <FieldLabel htmlFor='' labelText='追加' />
                  <DelButton size='small' design='primary' onClick={addEndType}>＋</DelButton>
                </InputField>
              </>
              :<></>}
          </SmallInputContainer>
        </Position>
      </EndTypeContainer>

    </Container>
  );
};

export default PlaceCameras;
